import { ISurvey, ISurveyResponse } from './survey-types';
import AdacaAPI from '..';

export interface IPostponeSurvey {
  file: string;
  intervention: string;
}

const findSurvey = async (file: string) => {
  const { data } = await AdacaAPI.get(`/Survey/${file}`);
  return data;
};

const getSurveyQuestions = async (file: string, intervention: string) => {
  const { data, status } = await AdacaAPI.get<ISurvey>(`/Survey/questions/${file}/${intervention}`);
  return { data, status };
};

const sendSurvey = async (body?: ISurveyResponse) => {
  if (!body) return;
  const { data } = await AdacaAPI.post(`/Survey`, body);
  return data;
};

const postPoneSurvey = async (body?: IPostponeSurvey) => {
  if (!body) return;
  const { data } = await AdacaAPI.post(`/survey/postpone`, body);
  return data;
};

export { getSurveyQuestions, findSurvey, sendSurvey, postPoneSurvey };
